var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "collapsible",
      class: { "collapsible--active": _vm.isActive },
    },
    [
      _c(
        "div",
        {
          staticClass: "collapsible__title",
          class: { "flex items-center justify-between": !_vm.isDisabled },
          on: {
            click: function ($event) {
              return _vm.toggle()
            },
          },
        },
        [
          _c("div", [_vm._t("title")], 2),
          _vm._v(" "),
          !_vm.isDisabled
            ? _c(
                "div",
                {
                  staticClass: "collapsible__toggle",
                  class: {
                    "collapsible__toggle--active": _vm.isActive,
                    "lg:hidden": _vm.isDesktopDisabled,
                  },
                },
                [
                  !_vm.useArrowIcons
                    ? _c("span", {
                        staticClass: "icon-plus",
                        class: {
                          block: !_vm.isActive,
                          hidden: _vm.isActive,
                        },
                      })
                    : _c(
                        "span",
                        {
                          staticClass: "icon-dropdown-arrow",
                          class: {
                            block: !_vm.isActive,
                            hidden: _vm.isActive,
                          },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "24",
                                height: "24",
                                viewBox: "0 0 24 24",
                                fill: "none",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  "fill-rule": "evenodd",
                                  "clip-rule": "evenodd",
                                  d: "M11.6023 8.33708C11.822 8.11741 12.1781 8.11741 12.3978 8.33708L18.1326 14.072C18.3523 14.2916 18.3523 14.6477 18.1326 14.8674L17.8674 15.1326C17.6478 15.3523 17.2916 15.3523 17.0719 15.1326L12 10.0607L6.92808 15.1326C6.7084 15.3523 6.3523 15.3523 6.13263 15.1326L5.86743 14.8674C5.64775 14.6477 5.64775 14.2916 5.86743 14.072L11.6023 8.33708Z",
                                  fill: "#fff",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                  _vm._v(" "),
                  !_vm.useArrowIcons
                    ? _c("span", {
                        staticClass: "icon-minus",
                        class: {
                          hidden: !_vm.isActive,
                          block: _vm.isActive,
                        },
                      })
                    : _c(
                        "span",
                        {
                          staticClass: "icon-dropdown-arrow",
                          class: {
                            hidden: !_vm.isActive,
                            block: _vm.isActive,
                          },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "24",
                                height: "24",
                                viewBox: "0 0 24 24",
                                fill: "none",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  "fill-rule": "evenodd",
                                  "clip-rule": "evenodd",
                                  d: "M11.6023 8.33708C11.822 8.11741 12.1781 8.11741 12.3978 8.33708L18.1326 14.072C18.3523 14.2916 18.3523 14.6477 18.1326 14.8674L17.8674 15.1326C17.6478 15.3523 17.2916 15.3523 17.0719 15.1326L12 10.0607L6.92808 15.1326C6.7084 15.3523 6.3523 15.3523 6.13263 15.1326L5.86743 14.8674C5.64775 14.6477 5.64775 14.2916 5.86743 14.072L11.6023 8.33708Z",
                                  fill: "#fff",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                ]
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c("collapse-transition", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isActive,
                expression: "isActive",
              },
            ],
            class: { "lg:block": _vm.isDesktopDisabled },
          },
          [
            _c(
              "div",
              { staticClass: "collapsible__content" },
              [_vm._t("default")],
              2
            ),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }